<div id="footer-bar" class="footer-bar-6">
  <a href="/accounting" class="<%= ( activeItem === 'accounting' ) ? 'active-nav' : '' %>">
    <i class="fa-solid fa-trophy-star"></i><span>ERFOLGE</span><em></em>
  </a>
  <a href="/" class="circle-nav <%= ( activeItem === 'index' ) ? 'active-nav' : '' %>">
    <i class="fa-solid fa-list-check"></i><span>YOUTINE</span><strong><u></u></strong><em></em>
  </a>
  <a href="/videos" class="<%= ( activeItem === 'videos' ) ? 'active-nav' : '' %>">
    <i class="fa-solid fa-video"></i><span>VIDEOS</span><em></em>
  </a>
</div>
